import { validateEnvironmentVariables } from '../../config/validation';
import { errorHandler } from '../error/errorHandler';

export const validateEnvironment = () => {
  const validation = validateEnvironmentVariables();
  
  if (!validation.isValid) {
    const error = new Error(
      `Missing required environment variables: ${validation.missingFields.join(', ')}`
    );
    errorHandler.handleError(error, 'critical', { missingFields: validation.missingFields });
    return false;
  }
  
  return true;
};